/*
 * HB Liefertermin (06.10.2026): eine Rechnung fuer Produktseite (sections/main-product.liquid,
 * #instock-pulse) und Warenkorb (snippets/cart-drawer.liquid, .hb-goodchoice).
 *
 * Regel: Bestellung an einem Werktag bis 15:00 Uhr (Europe/Berlin) → dieser Tag zaehlt,
 * sonst der naechste Werktag. Termin = Bestelltag + 3 Werktage (07.10.2026, vorher 4). Wochenenden und
 * bundesweite Feiertage zaehlen nicht. Countdown wie Amazon, solange die Grenze < 24 h entfernt ist.
 * Betriebsurlaub (Shop-Metafeld jarvis.vacation_until): Termin = Urlaubsende + 3 Werktage, ohne Countdown.
 */
(function () {
  var CUTOFF_H = 15, DAYS = 3, VACATION_DAYS = 3;

  function nowBerlin() { return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Berlin' })); }
  function addDays(d, n) { var x = new Date(d.getFullYear(), d.getMonth(), d.getDate()); x.setDate(x.getDate() + n); return x; }
  function ymd(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25),
      g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4,
      l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    return new Date(y, Math.floor((h + l - 7 * m + 114) / 31) - 1, ((h + l - 7 * m + 114) % 31) + 1);
  }
  var HOLI = {};
  function holidays(y) {
    if (!HOLI[y]) {
      var e = easter(y);
      HOLI[y] = [y + '-01-01', y + '-05-01', y + '-10-03', y + '-12-25', y + '-12-26',
        ymd(addDays(e, -2)), ymd(addDays(e, 1)), ymd(addDays(e, 39)), ymd(addDays(e, 50))];
    }
    return HOLI[y];
  }
  function isWorkday(d) { var w = d.getDay(); return w !== 0 && w !== 6 && holidays(d.getFullYear()).indexOf(ymd(d)) < 0; }
  function nextWorkday(d) { var x = addDays(d, 1); while (!isWorkday(x)) x = addDays(x, 1); return x; }
  function addWorkdays(d, n) { var x = d; for (var i = 0; i < n; i++) x = nextWorkday(x); return x; }
  function fmt(d) {
    return d.toLocaleDateString('de-DE', { weekday: 'short' }).replace('.', '') + ', ' +
      d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit' });
  }
  function vacationEnd(vacationUntil, today) {
    if (!vacationUntil) return null;
    var p = String(vacationUntil).split('-');
    if (p.length !== 3) return null;
    var v = new Date(+p[0], +p[1] - 1, +p[2]);
    return isNaN(v.getTime()) || v < today ? null : v;
  }

  /** Termin + Grenze. now optional (Tests), sonst jetzt in Europe/Berlin. */
  function plan(opts) {
    opts = opts || {};
    var now = opts.now || nowBerlin();
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var vac = vacationEnd(opts.vacationUntil, today);
    if (vac) return { date: addWorkdays(vac, VACATION_DAYS), vacation: true };
    var cutoffToday = isWorkday(today) && (now.getHours() < CUTOFF_H || (now.getHours() === CUTOFF_H && now.getMinutes() === 0));
    var orderDay = cutoffToday ? today : nextWorkday(today);
    var deadline = new Date(orderDay.getFullYear(), orderDay.getMonth(), orderDay.getDate(), CUTOFF_H, 0, 0);
    return { date: addWorkdays(orderDay, DAYS), deadline: deadline, msLeft: deadline - now, today: today, vacation: false };
  }

  function bis(p) {
    var t = addDays(p.today, 1);
    if (ymd(p.deadline) === ymd(p.today)) return 'bis 15 Uhr';
    if (ymd(p.deadline) === ymd(t)) return 'bis morgen 15 Uhr';
    return 'bis ' + p.deadline.toLocaleDateString('de-DE', { weekday: 'long' }) + ' 15 Uhr';
  }
  function left(ms) {
    if (ms <= 0 || ms >= 86400000) return null;
    var h = Math.floor(ms / 3600000), m = Math.floor((ms % 3600000) / 60000);
    return (h ? h + ' Std. ' : '') + m + ' Min.';
  }
  /** Bedingung: „innerhalb von 20 Std. 44 Min.“ bzw. „bis Montag 15 Uhr“ (HTML).
   *  „innerhalb von“ in .hb-lt-long: mobil ausgeblendet, damit die Zeile einzeilig bleibt (19.10.2026, buy-buttons.liquid). */
  function condition(p) {
    var l = left(p.msLeft);
    return l ? '<span class="hb-lt-long">innerhalb von </span><strong>' + l + '</strong>' : bis(p);
  }

  window.HBLiefertermin = {
    plan: plan,
    format: fmt,
    /** Produktseite (07.10., User): wieder konkretes Datum (Bestelltag + 3 Werktage) mit 15-Uhr-Bedingung,
     *  z. B. „Am Mo, 12.10. bei dir, wenn du innerhalb von 1 Std. 20 Min. bestellst.“ (gruen wie Snocks).
     *  Im Betriebsurlaub nur das Datum. */
    productHtml: function (opts) {
      var p = plan(opts);
      if (p.vacation) return '<span class="hb-lt">Am ' + fmt(p.date) + ' bei dir.</span>';
      return '<span class="hb-lt">Am ' + fmt(p.date) + ' bei dir, wenn du ' + condition(p) + ' bestellst.</span>';
    },
    /** Warenkorb: „<b>Gute Wahl!</b> In 3–4 Werktagen bei dir.“ (im Betriebsurlaub mit Datum) */
    cartHtml: function (opts) {
      var p = plan(opts);
      if (p.vacation) return '<strong>Gute Wahl!</strong> Am ' + fmt(p.date) + ' bei dir.';
      return '<strong>Gute Wahl!</strong> In 3–4 Werktagen bei dir.';
    }
  };
})();
